import { z } from "zod";

export const paginationMeta = z.object({
	page: z.coerce.number().int().min(1).default(1),
	limit: z.coerce.number().int().min(1).default(50),
});
export type paginationMetaDto = z.infer<typeof paging>;

export const paging = z.object({
	count: z.number(),
	currentPage: z.number(),
	nextPage: z.number().nullable(),
	prevPage: z.number().nullable(),
	totalPages: z.number(),
	totalCount: z.number(),
});
export type Paging = z.infer<typeof paging>;

export const paginateSchema = <Schema extends z.ZodTypeAny>(schema: Schema) =>
	z.object({
		data: z.array(schema),
		paging: paging,
	});
